module.exports = __webpack_public_path__ + "media/images/pic/anime/scooter-0c3bfd3b0fa604e06386e56d72894cae.svg";